<script>
import TextEllipsis from "@/components/commonComponents/TextEllipsis.vue";
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import _ from "lodash";
import ThesesTypes from "@/mixins/dictionaries/ThesesTypes";

export default {
    name: "VDataTableQuotesGrouped",
    components: {
        VDataTableCustom,
        TextEllipsis,
    },
    inheritAttrs: false,
    mixins: [
        ThesesTypes,
    ],
    props: {
        items: {
            type: Array,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Спикер',
                    align: 'start',
                    sortable: true,
                    value: 'speaker_name',
                    width: 100,
                    cellClass: 'cell-speaker'
                },
                {
                    text: 'Должность',
                    align: 'start',
                    sortable: true,
                    value: 'speaker_position',
                    width: 300,
                    cellClass: 'cell-position',
                },
                {
                    text: 'Текст',
                    align: 'start',
                    sortable: true,
                    value: 'text',
                },
            ],
            sort: {
                by: null,
                desc: null,
            },
        };
    },
    computed: {
        dictionariesThesesTypes() {
            return [].concat(this.dictionaries.thesesTypes, [{id: null, name: 'Без типа'}]);
        },
    },
    methods: {
        getThesesByType(type) {
            return _.filter(this.items, {sessions_summaries_theses_type: type});
        },
    },
}
</script>

<template>
    <div>
        <v-data-table-custom
            v-for="(thesisType, index) in dictionariesThesesTypes"
            v-bind="$attrs"
            v-on="$listeners"
            :key="thesisType.id"
            :items="getThesesByType(thesisType.id)"
            :headers="headers"
            :footer-props="{itemsPerPageOptions:[]}"
            :hide-default-header="!!index"
            :sort-by.sync="sort.by"
            :sort-desc.sync="sort.desc"
            group-by="sessions_summaries_theses_name"
            hide-default-footer
            item-key="id"
            permissions-by-module="quotes"
        >
            <template v-slot:body.prepend="{headers}">
                <tr class="v-row-group__header v-row-group__header--perpend">
                    <td :colspan="headers.length" class="text-h6">
                        {{ thesisType.name }}
                    </td>
                </tr>
            </template>
            <template v-slot:group.header="{headers, group, isOpen, toggle}">
                <td :colspan="headers.length" class="text-subtitle-2" @click="toggle">
                    <v-btn icon small>
                        <v-icon> {{ isOpen ? '$minus' : '$plus' }}</v-icon>
                    </v-btn>
                    {{ group || 'Без тезиса' }}
                </td>
            </template>
            <template v-slot:item.speaker_position="{value}">
                <text-ellipsis :multiline="2">
                    {{ value }}
                </text-ellipsis>
            </template>
            <template v-slot:item.text="{value}">
                <text-ellipsis :multiline="2">
                    {{ value }}
                </text-ellipsis>
            </template>
            <template v-slot:footer="{permissions}" v-if="index === dictionariesThesesTypes.length-1">
                <div class="v-data-footer" v-if="!!$listeners['click:add'] && permissions.canCreate">
                    <v-btn
                        @click="$emit('click:add')"
                        color="primary"
                    >
                        Добавить
                    </v-btn>
                </div>
            </template>
        </v-data-table-custom>
    </div>
</template>

<style scoped lang="css">
>>> .cell-speaker {
    width: 100px;
}

>>> .cell-position {
    width: 300px;
}

>>> .v-row-group__header--perpend ~ .v-row-group__header {
    cursor: pointer;
}
</style>
